import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "videoconference-link-switch" }
const _hoisted_2 = { class: "videoconference-link-switch__logo" }
const _hoisted_3 = ["src", "alt"]

import { computed, inject } from 'vue';
import { Translator } from 'js/shims-vue';

type Provider = 'google' | 'outlook';

interface Props {
    modelValue: boolean;
    provider: Provider;
    disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoconferenceLinkSwitch',
  props: {
    modelValue: { type: Boolean },
    provider: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const $t = inject('$t') as Translator;

const logoSrc = computed((): string => {
    return props.provider === 'google'
        ? '/ressources/logged/img/illustrations/common/logo/google-meet.svg'
        : '/ressources/logged/img/illustrations/common/logo/microsoft-teams.svg';
});

const logoAlt = computed((): string => {
    return props.provider === 'google' ? 'Google Meet' : 'Microsoft Teams';
});

const switchLabel = computed((): string => {
    return props.provider === 'google'
        ? $t.__('activities.activitiesFormPanel.add_google_meet_link')
        : $t.__('activities.activitiesFormPanel.add_teams_link');
});

const switchCaption = computed((): string => {
    return props.provider === 'google'
        ? $t.__('activities.activitiesFormPanel.google_meet_caption')
        : $t.__('activities.activitiesFormPanel.teams_caption');
});

return (_ctx: any,_cache: any) => {
  const _component_CompassSwitch = _resolveComponent("CompassSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: logoSrc.value,
        alt: logoAlt.value
      }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    _createVNode(_component_CompassSwitch, {
      modelValue: __props.modelValue,
      label: switchLabel.value,
      caption: switchCaption.value,
      disabled: __props.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
    }, null, 8 /* PROPS */, ["modelValue", "label", "caption", "disabled"])
  ]))
}
}

})